module.exports = __webpack_public_path__ + "img/front neck drop.4d9253c2.png";